import React, { createContext, useState, useEffect, useContext } from 'react';
import { FormValidationContext } from './FormValidationProvider';

const initialContext = {
  setSteps: () => {},
  setCurrentStep: () => {},
  stepsValidationStatus: [],
  scrollIndex: '',
  setScrollIndex: () => {},
  setVisitedDrivers: () => {},
  visitedDrivers: false,
  deletingItem: '',
  setDeletingItem: () => {},
};

export const StepsValidationStatusContext = createContext(initialContext);

const StepsValidationStatusProvider = ({ children }) => {
  const [steps, setSteps] = useState();
  const [currentStep, setCurrentStep] = useState();
  const [stepsValidationStatus, setStepsValidationStatus] = useState([]);
  const [scrollIndex, setScrollIndex] = useState();
  const [visitedDrivers, setVisitedDrivers] = useState(false);
  const [deletingItem, setDeletingItem] = useState({
    id: '',
    message: ''
  });

  const { isValid, formStatuses } = useContext(FormValidationContext);

  const initialValidation = () => {
    if (steps && steps.length && Array.isArray(steps)) {
      const updatedSteps = steps.map((step) => {
        return {
          ...step,
          valid: false,
        };
      });
      setStepsValidationStatus(updatedSteps);
    }
  };

  useEffect(() => {
    updateStatus(currentStep);
  }, [isValid, currentStep, formStatuses]);

  useEffect(() => {
    initialValidation();
  }, [steps]);

  const updateStatus = (currentStep) => {
    if (!stepsValidationStatus) return;

    const updatedArray = stepsValidationStatus.map((step, index) => {
      if (index === currentStep) {
        return {
          ...step,
          valid: isValid,
        };
      }
      return step;
    });

    return setStepsValidationStatus(updatedArray);
  };

  return (
    <StepsValidationStatusContext.Provider
      value={{
        ...initialContext,
        setSteps,
        setCurrentStep,
        stepsValidationStatus,
        scrollIndex,
        setScrollIndex,
        setVisitedDrivers,
        visitedDrivers,
        deletingItem,
        setDeletingItem,
      }}
    >
      {children}
    </StepsValidationStatusContext.Provider>
  );
};

export default StepsValidationStatusProvider;
